import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DeliveryAlertToast.css';

/**
 * The live-tab counterpart to the OS push notification — same event, same
 * "Delivery <invoice> — <customer>" identity, so a user who has the app open
 * sees the identical story the push would have told them, just without a
 * system notification (they're already looking at the screen).
 *
 * Stacks a short queue rather than replacing in place: two deliveries starting
 * within a few seconds of each other should both be seen, not have the second
 * silently overwrite the first before it's read.
 */
const DeliveryAlertToast = ({ alerts, onDismiss }) => {
    const navigate = useNavigate();
    if (!alerts.length) return null;

    return (
        <div className="delivery-alert-stack" role="region" aria-label="Delivery notifications">
            {alerts.map((alert) => (
                <div key={alert.id} className={`delivery-alert-toast delivery-alert-toast--${alert.kind}`} role="status">
                    <span className="delivery-alert-toast__icon">
                        {alert.kind === 'started' ? '🚚' : alert.kind === 'assigned' ? '📦' : '📸'}
                    </span>
                    <div className="delivery-alert-toast__body">
                        <div className="delivery-alert-toast__title">{alert.title}</div>
                        <div className="delivery-alert-toast__detail">{alert.detail}</div>
                    </div>
                    <button
                        type="button"
                        className="delivery-alert-toast__open"
                        onClick={() => { navigate('/delivery-management'); onDismiss(alert.id); }}
                    >
                        Open
                    </button>
                    <button
                        type="button"
                        className="delivery-alert-toast__close"
                        aria-label="Dismiss"
                        onClick={() => onDismiss(alert.id)}
                    >
                        &times;
                    </button>
                </div>
            ))}
        </div>
    );
};

export default DeliveryAlertToast;
